export const uiLang = ['en', 'fr', 'id', 'pt', 'ru'];

export const uiLangDev = [
  'en',
  'fr',
  'pt',
  'ta',
  'ar',
  'es',
  'ha',
  'id',
  'ru',
  'sw',
];
